import script from "./TreeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeItem.vue?vue&type=script&setup=true&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=0a9c87cc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9c87cc"]])

export default __exports__